<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.66699 10.4C6.66699 8.15979 6.66699 7.03969 7.10297 6.18404C7.48646 5.43139 8.09838 4.81947 8.85103 4.43597C9.70668 4 10.8268 4 13.067 4H18.9337C21.1739 4 22.294 4 23.1496 4.43597C23.9023 4.81947 24.5142 5.43139 24.8977 6.18404C25.3337 7.03969 25.3337 8.15979 25.3337 10.4V28L16.0003 22.6667L6.66699 28V10.4Z" fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
